import { Button } from '@material-ui/core';
import { FiCopy } from 'react-icons/fi';

import { useBooleanState } from '../../../../hooks';
import { ConfirmDialog } from '../../../../components';

export const ApplyToAllShiftButton = ({ handleConfirm }: { handleConfirm: () => void }) => {
  const [isSuccessDialogOpen, setSuccessDialogOpen, setSuccessDialogClose] = useBooleanState(false);

  const handleClick = () => {
    handleConfirm();
    setSuccessDialogClose();
  };
  return (
    <>
      <Button
        endIcon={<FiCopy />}
        variant="outlined"
        color="primary"
        size="small"
        onClick={setSuccessDialogOpen}
      >
        Apply to all Shifts
      </Button>
      <ConfirmDialog
        handleClose={setSuccessDialogClose}
        open={isSuccessDialogOpen}
        confirmText="Yes, apply"
        cancelText="Cansel"
        title="Do you want to apply those settings to all the Shifts?"
        subtitle="Any custom settings set for individual Shifts will be overwritten. This action cannot be undone."
        handleConfirm={handleClick}
      />
    </>
  );
};
